import { render, staticRenderFns } from "./NotificationManage.vue?vue&type=template&id=fd4f15be&scoped=true&"
import script from "./NotificationManage.vue?vue&type=script&lang=js&"
export * from "./NotificationManage.vue?vue&type=script&lang=js&"
import style0 from "./NotificationManage.vue?vue&type=style&index=0&id=fd4f15be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4f15be",
  null
  
)

export default component.exports